import {
  UPDATE_ATTENDENCE,
  UPDATE_ATTENDANCE_TIME_INFORMATIONS,
  SET_ATTENDANCE_INFORMATIONS_COMMUNICATOR,
  UPDATE_AVATAR_ATTENDANCE,
  RESET_ATETENDANCE,
  UPDATE_AGENT_DEFAULT_CAMPAIGN,
  SET_USER_ADDED,
  SET_ORG_UNIT_INFORMATION,
  UPDATE_ACK_CALL_REQUEST,
  UPDATE_ACK_CALL_VOLUME,
  UPDATE_CALL_CONTROL_BEHAVIOR,
  UPDATE_AFTER_ATTENDANCE_BEHAVIOR,
  SET_ATTENDANCE_DETAILS,
  SET_ATTENDANCE_DETAILS_DTO,
  SET_ORGANIA_OPEN_URL_DIALOG,
  SET_ORGANIA_DONT_ASK_AGAIN,
  UPDATE_WEBRTC_AUTO_RECONNECT,
  UPDATE_AGENT_ABSENT_STATUS,
  SET_NOTIFICATIONS,
  SET_VIEW_MODAL_FEEDBACK,
} from '../../mutation-types';
import Attendance from '../../../weon/models/Attendance';
import Vue from 'vue';

const mutations = {
  [UPDATE_ATTENDENCE](state, informations) {
    state.Attendance = informations;
  },

  [UPDATE_CALL_CONTROL_BEHAVIOR](state, value) {
    Vue.set(state.Attendance.agentPreferences, 'callControlBehavior', value);
  },

  [UPDATE_AFTER_ATTENDANCE_BEHAVIOR](state, value) {
    Vue.set(
      state.Attendance.agentPreferences,
      'afterAttendanceBehavior',
      value,
    );
  },

  [UPDATE_ATTENDANCE_TIME_INFORMATIONS](state, timeInformations) {
    Vue.set(state.Attendance, 'timeInformations', timeInformations);
  },

  [UPDATE_AVATAR_ATTENDANCE](state, avatar) {
    Vue.set(state.Attendance, 'avatar', avatar);
  },

  [SET_ATTENDANCE_DETAILS](state, details) {
    Vue.set(state.Attendance, 'agentDetails', details);
  },
  [SET_ATTENDANCE_DETAILS_DTO](state, details) {
    state.agentDetails = details;
  },

  [SET_ATTENDANCE_INFORMATIONS_COMMUNICATOR](state, informationsCommunicator) {
    state.informationsCommunicator = informationsCommunicator;
  },

  [RESET_ATETENDANCE](state) {
    state.Attendance = new Attendance();
  },

  [SET_USER_ADDED](state, body) {
    state.UserAdded = body;
  },

  [UPDATE_AGENT_DEFAULT_CAMPAIGN](state, updateCampaign) {
    if (updateCampaign.channel == 'voice') {
      Vue.set(
        state.Attendance,
        'campaignVoiceDefault',
        updateCampaign.campaignId,
      );
    }
    if (updateCampaign.channel == 'whatsapp') {
      Vue.set(
        state.Attendance,
        'campaignWhatsappDefault',
        updateCampaign.campaignId,
      );
    }
  },
  [SET_ORG_UNIT_INFORMATION](state, orgUnitInformation) {
    state.orgUnitInformation.id = orgUnitInformation.id;
    state.orgUnitInformation.name = orgUnitInformation.name;
    state.orgUnitInformation.broadcastWhatsappEnabled =
      orgUnitInformation.broadcastWhatsappEnabled;
  },
  [UPDATE_ACK_CALL_REQUEST](state, ackCallStatus) {
    state.Attendance.agentAckCall = ackCallStatus;
  },
  [UPDATE_ACK_CALL_VOLUME](state, ackCallVolume) {
    state.Attendance.agentAckCallVolume = ackCallVolume;
  },
  [SET_ORGANIA_OPEN_URL_DIALOG](state, value) {
    state.organia.churnBusterDialog = value;
  },
  [SET_ORGANIA_DONT_ASK_AGAIN](state, value) {
    state.organia.churnBusterDontAskAgain = value;
  },
  [UPDATE_WEBRTC_AUTO_RECONNECT](state, webRtcAutoReconnect) {
    state.Attendance.agentPreferences.webRtcAutoReconnect = webRtcAutoReconnect;
  },
  [UPDATE_AGENT_ABSENT_STATUS](state, response) {
    if (response.success) {
      state.Attendance.agentAbsent.agentAbsentEnabled = false;
    }
  },
  [SET_NOTIFICATIONS](state, { type, value }) {
    value = value === 1;
    Vue.set(state.Attendance.agentPreferences, type, value);
  },
  [SET_VIEW_MODAL_FEEDBACK](state, value) {
    Vue.set(state.Attendance, 'viewModalFeedback', value);
  },
};

export default mutations;
